// Videos

window.SiteReady(($) => {
  console.log('Init: Video');

  // Not Used

  // if ($('.js-video_modal, .js-video_swap').length > 0 && $('script[src*="youtube.com/iframe_api"]').length == 0) {
  //   $('head').append('<script src="//www.youtube.com/iframe_api"></script>');
  // }

  // let originalYouTubeCallback = window.onYouTubeIframeAPIReady || null; // Fixes background race condition

  // window.onYouTubeIframeAPIReady = () => {
  //   if (typeof originalYouTubeCallback == 'function') {
  //     originalYouTubeCallback();
  //   }
  // }

  function playVideo($iframe) {
    // $('iframe.playing').not('.autoplay').each(function(el) {
    //   pauseVideo($(el));
    // });

    // $iframe.addClass('playing');

    if ($iframe.data('provider') == 'SproutVideo') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({name:"play"}), '*');
    }
    if ($iframe.data('provider') == 'YouTube') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({event:"command",func:"playVideo",args:""}), '*');
    }
    if ($iframe.data('provider') == 'Vimeo') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({method:"play"}), '*');
    }
  }

  function pauseVideo($iframe) {
    // $iframe.removeClass('playing');

    if ($iframe.data('provider') == 'SproutVideo') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({name:"pause"}), '*');
    }
    if ($iframe.data('provider') == 'YouTube') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({event:"command",func:"pauseVideo",args:""}), '*');
    }
    if ($iframe.data('provider') == 'Vimeo') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({method:"pause"}), '*');
    }
  }

  function muteVideo($iframe) {
    if ($iframe.data('provider') == 'SproutVideo') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({name:"volume",data:0}), '*');
    }
    if ($iframe.data('provider') == 'YouTube') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({event:"command",func:"mute",args:""}), '*');
      $iframe[0].contentWindow.postMessage(JSON.stringify({event:"command",func:"setVolume",args:[0]}), '*');
    }
    if ($iframe.data('provider') == 'Vimeo') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({method:"mute"}), '*');
      $iframe[0].contentWindow.postMessage(JSON.stringify({method:"setVolume",value:0}), '*');
    }

    $iframe.next('.js-video_audio_control').addClass('muted');
  }

  function unmuteVideo($iframe) {
    if ($iframe.data('provider') == 'SproutVideo') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({name:"volume",data:1}), '*');
    }
    if ($iframe.data('provider') == 'YouTube') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({event:"command",func:"unMute",args:""}), '*');
      $iframe[0].contentWindow.postMessage(JSON.stringify({event:"command",func:"setVolume",args:[100]}), '*');
    }
    if ($iframe.data('provider') == 'Vimeo') {
      $iframe[0].contentWindow.postMessage(JSON.stringify({method:"unmute"}), '*');
      $iframe[0].contentWindow.postMessage(JSON.stringify({method:"setVolume",value:1}), '*');
    }

    $iframe.next('.js-video_audio_control').removeClass('muted');
  }

  //

  // $('.js-video_swap, .js-video_modal').on('swap:activate', (e) => {
  $('.js-video_swap').on('swap:activate', (e) => {
    const $target = $(e.currentTarget);
    const $iframe = $target.find('.js-video_player');

    $iframe.data('state', 'play');

    // Clicked before the page finished loading, so the player hasn't been
    // preloaded yet (see loadClickPlayers below). Load it now with autoplay:
    // the click is the user gesture browsers require, and a player that's
    // still loading isn't ready for a play command.
    if (!$iframe.attr('src')) {
      const src = $iframe.data('src');
      const separator = src.indexOf('?') > -1 ? '&' : '?';

      $iframe.attr('src', `${src}${separator}autoplay=1`);

      return;
    }

    playVideo($iframe);

    // let windowWidth = window.innerWidth;

    // if (windowWidth < 740) {
    //   document.documentElement.requestFullscreen();
    // }
  }).on('swap:deactivate', (e) => {
    const $target = $(e.currentTarget);
    const $iframe = $target.find('.js-video_player');

    pauseVideo($iframe);

    $iframe.data('state', 'pause');

    // if (document.fullscreenElement != null) {
    //   document.exitFullscreen();
    // }
  });

  $('.js-video_modal').on('click', (e) => {
    const $target = $(e.currentTarget);

    if ($target.hasClass('js-video_modal')) {
      $target.find('.js-video_modal_close').swap('deactivate');
    }
  });

  //

  function observeVideos(entries) {
    entries.forEach(function(entry) {
      const $iframe = $(entry.target);
      const state = $iframe.data('state');

      // Any playing video pauses when it leaves the viewport; only
      // autoplaying ones resume on their own when it comes back. A
      // click-to-play video is never paused while in view, which also covers
      // the observer's first callback when a player loads mid-play.
      if (state == 'play') {
        if (!entry.isIntersecting) {
          pauseVideo($iframe);
        } else if ($iframe.hasClass('autoplay')) {
          playVideo($iframe);
        }
      }
    });
  }

  const observer = new IntersectionObserver(observeVideos, {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: 0.1
  });

  //

  function initVideoPlayer($target) {
    const $player = $target.data('videoPlayer');

    if (typeof $player == 'undefined') {
      const $iframe = $target.find('.js-video_player');

      $target.data('videoPlayer', $iframe);

      $iframe.on('load', () => {
        observer.observe($iframe[0]);
      });

      // Autoplaying players load now (they play once scrolled into view);
      // click-to-play players are preloaded once the page has loaded
      if ($iframe.hasClass('autoplay') && typeof $iframe.attr('src') == 'undefined') {
        $iframe.attr('src', $iframe.data('src'));
      }
    }
  }

  // Preloads click-to-play players after the page itself has loaded, so they
  // don't compete with it, and so a click plays straight away rather than
  // waiting on the player to load. The iframes are loading="lazy", so the
  // browser still only fetches each one as it nears the viewport.
  function loadClickPlayers() {
    $('.js-video_swap .js-video_player').each((_, player) => {
      const $player = $(player);

      if (typeof $player.attr('src') == 'undefined') {
        $player.attr('src', $player.data('src'));
      }
    });
  }

  if (document.readyState === 'complete') {
    loadClickPlayers();
  } else {
    $(window).on('load', loadClickPlayers);
  }

  // window.addEventListener('message', function() {
  //   console.log(arguments[0].origin, arguments[0].data);
  // });

  // $('.js-video_swap, .js-video_modal').each((i, el) => {
  $('.js-video_swap').each((_, videoSwap) => {
    initVideoPlayer($(videoSwap));
  });

  // $('.js-video_swap iframe').each((i, el) => {
  //   observer.observe(el);
  // });

  $('.js-video_audio_control').on('click', (e) => {
    const $target = $(e.currentTarget);
    const $iframe = $target.prev('iframe');
    let audio = $iframe.data('audio');

    if (!audio) {
      audio = 'off';
    }

    if (audio == 'off') {
      unmuteVideo($iframe);

      $iframe.data('audio', 'on');
    } else {
      muteVideo($iframe);

      $iframe.data('audio', 'off');
    }
  });

});
